import React, { useState } from "react";
import Button from "../../../../components/shared/Button";
import { ApiService } from "../../../../services/apiService";
import { toast } from "react-toastify";
import AffiliateDetailsTable from "./components/AffiliateDetailsTable";

const Affiliate = () => {
  const [affiliateCode, setAffiliateCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [affiliateCodeData, setAffiliateCodeData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const getCodeDetails = async (e) => {
    e.preventDefault();
    if (!affiliateCode.trim()) {
      toast.warning("Please enter a referral code to search.");
      return;
    }
    setIsLoading(true);
    try {
      const response = await ApiService.getAffiliateCodeUsage(affiliateCode);
      if (response.status === 200) {
        setAffiliateCodeData(response.data.data);
        toast.success("Successfully fetched referral code details");
      }
    } catch (error) {
      toast.error(error.response.data.message || "Something went wrong");
    }
    setIsLoading(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await ApiService.createAffiliateCode({
        referral_code: affiliateCode,
      });

      if (response.status === 201 || response.data.code === 201) {
        const referralLink = `https://www.igcarts.com/signup?referral_code=${affiliateCode}`;
        try {
          await navigator.clipboard.writeText(referralLink);
          toast.success("Referral link copied to clipboard!");
        } catch (err) {
          prompt(
            "Copy this referral link manually (Clipboard not supported):",
            referralLink
          );
        }
        setAffiliateCode("");
        // toast.success(response.data.message);
      }
    } catch (error) {
      toast.error("Error creating affiliate code.");
    }

    setLoading(false);
  };

  return (
    <div className="mt-7 max-w-3xl mx-auto">
      <h4 className="font-bold text-center text-xl mb-3">
        Generate raferral code
      </h4>
      <form onSubmit={handleSubmit}>
        <div className="flex justify- gap-2 mb-5 sm:flex-col xs:flex-col md:flex-wrap lg:flex-wrap">
          <input
            type="text"
            name="affiliateCode"
            placeholder="kj8yzA"
            value={affiliateCode}
            onChange={(e) => setAffiliateCode(e.target.value)}
            required
            disabled={loading}
            className="shadow-sm bg-white outline-none border flex-1 border-gray-300 p-1 rounded-md"
          />
          <Button
            type="submit"
            title={loading ? "Generating code..." : "Generate Code "}
            disabled={loading}
            variant="primary"
          />
          <Button
            type="button"
            title={isLoading ? "Getting referrals..." : "See referrals"}
            disabled={isLoading}
            onClick={getCodeDetails}
            variant="secondary"
          />
        </div>
      </form>
      {affiliateCodeData.length > 0 && (
        <AffiliateDetailsTable
          affiliateCode={affiliateCode}
          affiliateCodeData={affiliateCodeData}
        />
      )}
    </div>
  );
};

export default Affiliate;
